<template>
  <div v-if="selectedFilter && selectedFilter.filter">
    <div
      v-if="selectedFilter.filter.type === 'select' && selectedFilter.values"
      class="row q-gutter-y-sm q-pa-sm"
    >
      <q-select
        transition-duration="100"
        :model-value="selectedFilter.values"
        label="is any of"
        class="full-width"
        dense
        use-chips
        use-input
        outlined
        input-debounce="0"
        multiple
        :options="selectOptions"
        @filter="filterFn"
        @update:model-value="$emit('update:values', $event)"
      />
    </div>
    <div v-else-if="selectedFilter.filter.type === 'range'" class="row q-gutter-sm q-pa-sm">
      <q-input
        label="Min"
        :model-value="selectedFilter.minValue as number"
        dense
        outlined
        type="number"
        style="width: 100px"
        @update:model-value="$emit('update:minValue', parseFloat($event as string))"
      />
      <q-input
        label="Max"
        :model-value="selectedFilter.maxValue as number"
        dense
        outlined
        type="number"
        style="width: 100px"
        @update:model-value="$emit('update:maxValue', parseFloat($event as string))"
      />
    </div>
    <div v-else-if="selectedFilter.filter.type === 'date'" class="row q-gutter-sm q-pa-sm">
      <date-range-picker
        :date-range="{
          from: selectedFilter.minValue as Date | null,
          to: selectedFilter.maxValue as Date | null
        }"
        :title="selectedFilter.filter.label"
        :use-date-constraints="false"
        :footer="false"
        btn-label="Listings last seen date"
        class="q-mt-md"
        @update="updateDateRange"
      />
    </div>
  </div>
</template>
<script lang="ts">
import type { PropType } from 'vue'
import type { PropertyDetailsResponse, Availability } from 'common'
import DateRangePicker from '@/components/DateRangePicker.vue'
type Row = Availability & {
  prop: PropertyDetailsResponse
}

export default {
  name: 'FilterPopover',
  components: { DateRangePicker },
  props: {
    selectedFilter: {
      type: Object as PropType<{
        filter: {
          label: string
          type: string
          options: (string | number)[]
          isValid: (row: Row) => boolean
        } | null
        values: (string | number)[]
        minValue: null | number | Date
        maxValue: null | number | Date
      }>,
      default: null
    }
  },
  emits: ['update:values', 'update:minValue', 'update:maxValue'],
  data() {
    return {
      selectOptions: [] as (string | number)[]
    }
  },
  created() {
    this.selectOptions = this.selectedFilter?.filter?.options || []
  },
  methods: {
    filterFn(val: string, update: (cbk: () => void) => void) {
      update(() => {
        const search = val.toLowerCase()
        this.selectOptions = (this.selectedFilter?.filter?.options || []).filter((v) =>
          String(v).toLowerCase().includes(search)
        )
      })
    },
    updateDateRange(obj: { from: Date; to: Date }) {
      this.$emit('update:minValue', obj.from)
      this.$emit('update:maxValue', obj.to)
    }
  }
}
</script>
